import {api} from './requestGraphql'

const countries = async () => {

  try {
    const res = await api.post(
      '', {
        query: `
          {
            countries{
                code    
                name
            } 
          }
        `,
      }
    )

    let response = res.data.data.countries
    return response
  } catch (e) {
    console.log(e)
  }

}

export default {
  countries
}